'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.reducer = reducer;
exports.mediaChanged = mediaChanged;
exports.mediaQueryTracker = mediaQueryTracker;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var listeners = [];
var MEDIA_CHANGED = exports.MEDIA_CHANGED = '@@rdx-mqt/MEDIA_CHANGED';

// Reducer
function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	var action = arguments[1];

	switch (action.type) {
		case MEDIA_CHANGED:
			return Object.assign({}, state, action.data);
		default:
			return state;
	}
}

// Actions
function mediaChanged(data) {
	return {
		type: MEDIA_CHANGED,
		data: data
	};
}

var trackInnerWidth = false;
var trackInnerHeight = false;
var onResize = void 0;
var getSizes = function getSizes(data) {
	if (trackInnerWidth) {
		data.innerWidth = global.innerWidth;
	}
	if (trackInnerHeight) {
		data.innerHeight = global.innerHeight;
	}
};
var makeOnResize = function makeOnResize(dispatch) {
	return function () {
		var data = {};
		getSizes(data);
		dispatch(mediaChanged(data));
	};
};
function trackMediaQuery(label, query, dispatch, initData) {
	// special queries
	if (label === 'innerWidth' || label === 'innerHeight') {
		if (label === 'innerWidth') {
			trackInnerWidth = true;
		}
		if (label === 'innerHeight') {
			trackInnerHeight = true;
		}
		if (!onResize) {
			onResize = makeOnResize(dispatch);
			if (global.addEventListener) {
				global.addEventListener('resize', onResize, true);
			}
		}
		getSizes(initData);
	}

	var mq = global.matchMedia(query);

	var listener = function listener() {
		return dispatch(mediaChanged(_defineProperty({}, label, mq.matches)));
	};
	mq.addListener(listener);

	initData[label] = mq.matches;
	return;
}

function mediaQueryTracker(queries) {
	return function (dispatch) {
		var initData = {};
		if (global.matchMedia) {
			for (var label in queries) {
				trackMediaQuery(label, queries[label], dispatch, initData);
			}
			dispatch(mediaChanged(initData));
		}
	};
}


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/redux-mediaquery/lib/media-query-tracker.js
// module id = 618
// module chunks = 4